export default "__VITE_ASSET__ecFeqIqL__"